import { jsx as d } from "react/jsx-runtime";
import { createContext as b, isValidElement as g, useContext as v, useState as j, useEffect as y } from "react";
import { flattener as O } from "@made-people/flatten-object";
const a = b(void 0), w = (e) => /* @__PURE__ */ d(a.Provider, { value: e.value, children: e.children });
function h(e) {
  return Object.prototype.toString.call(e) === "[object Object]" && Object.keys(e).every((r) => typeof r == "string") || typeof e == "function";
}
function k(e) {
  return e instanceof Date && !isNaN(e.getTime());
}
const x = (e) => g(e) || k(e), c = O("///", {
  skipFlatten: x
});
function u(e, r) {
  const t = c.flatten(e), n = c.flatten(r), o = { ...t, ...n };
  return c.unflatten(o);
}
function l(e) {
  return typeof e == "function" ? e() : e;
}
function P(e, r, t) {
  let n = e;
  const o = l(r), s = l(t);
  return r && (n = u(o, n)), t && (n = u(n, s)), n;
}
function M(e, r) {
  if (!(typeof r > "u"))
    return h(r) || console.warn(
      `Managed prop object set for component "${e}" is an invalid ManagedPropsPropObject: ${JSON.stringify(
        r
      )}`
    ), r;
}
const F = (e) => {
  var o, s;
  const r = v(a), [t, n] = j((o = r == null ? void 0 : r.deferredOverrideProps) == null ? void 0 : o[e]);
  return y(() => {
    var i;
    t !== void 0 && n((i = r == null ? void 0 : r.deferredOverrideProps) == null ? void 0 : i[e]);
  }, [(s = r == null ? void 0 : r.deferredOverrideProps) == null ? void 0 : s[e]]), t === null ? null : M(e, t);
}, p = (e, r) => {
  var n;
  const t = v(a);
  return M(r, (n = t == null ? void 0 : t[e]) == null ? void 0 : n[r]);
};
function C(e, r) {
  const t = O(e, { skipFlatten: g });
  return function(n) {
    return /* @__PURE__ */ d(r, { ...t.unflatten(n) });
  };
}
const E = (e, r) => {
  r.displayName = e;
  const t = (n) => {
    const o = p("fallbackProps", e), s = p("overrideProps", e), i = F(e);
    if (i === null)
      return null;
    let f = P(n, o, s);
    return i && (f = P(f, void 0, i)), /* @__PURE__ */ d(r, { ...f });
  };
  return t.displayName = `ManagedProps(${e})`, t;
};
export {
  w as ManagedPropsProvider,
  h as isManagedPropsPropObject,
  a as managedPropsContext,
  P as mergeProps,
  u as propMerger,
  M as resolveManagedProps,
  F as useManagedDeferredOverrideProps,
  p as useManagedProps,
  C as withDelimitedProps,
  E as withManagedProps
};
